// F15: fester XP-Topf pro Kampf. 30 % gleichmäßig, 70 % nach Beitrag.
import type { CombatRules } from '../content/index.ts';
import type { Contribution, Outcome } from './types.ts';

/** F15, R25: Der Topf hängt an den Feldplätzen, nicht an den Aufgestellten, mal Sturmstufe. */
export function xpPot(rules: CombatRules, fieldSlots: number, xpFactor: number): number {
  return rules.xp.perFieldSlot * fieldSlots * xpFactor;
}

/** K20: Beitragspunkte, Einstecken zählt mehr als Austeilen [ZAHL?] */
export function contributionScore(rules: CombatRules, c: Contribution): number {
  const w = rules.xp.weights;
  return c.damage * w.damage + c.taken * w.taken + c.healed * w.healed + c.shielded * w.shielded + c.kills * rules.xp.killBonus;
}

/**
 * Verteilt den Topf auf alle Freunde, die auf dem Feld standen (Objekte bekommen nichts, K5).
 * K14: Bei Niederlage oder Rückzug gibt es nichts.
 */
export function distributeXp(rules: CombatRules, pot: number, contributions: Contribution[], outcome: Outcome): number[] {
  if (outcome !== 'win' || contributions.length === 0) return contributions.map(() => 0);
  const even = (pot * rules.xp.evenShare) / contributions.length;
  const scores = contributions.map((c) => contributionScore(rules, c));
  const total = scores.reduce((a, b) => a + b, 0);
  const byContribution = pot * (1 - rules.xp.evenShare);
  return scores.map((s) => even + (total > 0 ? (byContribution * s) / total : byContribution / contributions.length));
}
